import React from "react";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { AspectRatio } from "@/components/ui/aspect-ratio";
export default function MosJourneyBrandOrigin() {
  return <section data-section-id="249915" id="overview" className="bg-background text-foreground py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          
          {/* Text Content Column */}
          <div className="lg:col-span-7 flex flex-col justify-center space-y-8">
            <div className="space-y-4">
              <Badge variant="outline" className="border-primary/20 text-primary tracking-wider uppercase text-xs">
                Seller Advantages
              </Badge>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold leading-tight tracking-tight text-foreground">
                Maximize Your Sale With <br className="hidden md:block" />
                A Pre-Listing Inspection
              </h2>
              <Separator className="w-24 h-1 bg-primary/20" />
            </div>

            <div className="space-y-6 text-lg md:text-xl text-muted-foreground font-sans leading-relaxed">
              <p>
                Selling your home is a major milestone, and surprises during the closing process are the last thing you need. A pre-listing inspection puts the power back in your hands by identifying potential issues before your property even hits the market.
              </p>
              <p>
                By addressing repairs early, you eliminate the stress of last-minute negotiations and prevent buyers from demanding heavy credits. This proactive approach demonstrates transparency and builds immediate trust with prospective buyers, often leading to faster offers and smoother closings.
              </p>
              <p>
                Our comprehensive reports provide a clear roadmap for your home's condition. Whether you choose to make repairs or disclose them upfront, you’ll have a clearer understanding of the property’s observed condition and can make more informed decisions before listing.
              </p>
            </div>
          </div>

          {/* Image Column */}
          <div className="lg:col-span-5 relative">
            {/* Main Image */}
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <AspectRatio ratio={3 / 4}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/pre_listing_inspection_pro.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/pre_listing_inspection_pro.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/pre_listing_inspection_pro.png-wvc-sizes" alt="Professional home inspector checking a property before listing" className="object-cover w-full h-full" loading="lazy" />
                {/* Overlay for depth */}
                <div className="absolute inset-0 bg-gradient-to-t from-secondary/40 to-transparent mix-blend-multiply" />
              </AspectRatio>
            </div>

            {/* Decorative Background Element */}
            <div className="absolute -z-10 top-1/2 -translate-y-1/2 right-0 translate-x-1/3 w-64 h-64 bg-primary/10 rounded-full blur-3xl opacity-50" />
          </div>

        </div>
      </div>
    </section>;
}